import { twMerge } from '@panwds/tailwindcss';
import React from 'react';
const appearanceVariants = {
    bold: 'tw-font-bold',
    semibold: 'tw-font-semibold'
};
/**
 * Renders its children in **bold** font.
 *
 *  ### Import Guide
 *
 * ```jsx
 * import { Bold } from "@panwds/react-ui";
 * ```
 */
export function Bold({ addClassName, appearance = 'bold', children, dataMetrics, dataTestId, as: Component = 'span', ...passThrough }) {
    const className = twMerge('tw-font-lato dark:tw-text-gray-100', appearanceVariants[appearance], addClassName);
    return (React.createElement(Component, { "data-metrics": dataMetrics, "data-testid": dataTestId || 'bold', className: className, ...passThrough }, children));
}
//# sourceMappingURL=Bold.js.map